/**
 * Dev-only floating button that fires the brand-app handoff redirect
 * without making the operator click through every funnel step. Useful
 * for iterating on the `?ad_h=…&au_h=1` handoff contract and the
 * brand-app's `<SilentSsoHandoff />` consumer in spicychat-frontend.
 *
 * Tree-shaken out of production builds via `import.meta.env.DEV`. Mount
 * it inside `<Funnel>` so it shares the same `useHandoffRedirect`
 * instance the real terminal step would use — the URL produced is
 * identical to the live flow.
 */

import type { ReactElement } from "react";

type DevHandoffShortcutProps = {
  onTrigger: () => void;
};

const DevHandoffShortcut = ({ onTrigger }: DevHandoffShortcutProps): ReactElement | null => {
  if (!import.meta.env.DEV) return null;

  return (
    <button
      type="button"
      onClick={onTrigger}
      className="fixed bottom-3 right-3 z-50 rounded-full bg-black/70 px-3 py-1.5 text-xs font-medium text-white shadow-lg backdrop-blur hover:bg-black/85"
      aria-label="Dev-only: skip funnel and trigger brand-app handoff redirect"
    >
      Skip → handoff
    </button>
  );
};

export default DevHandoffShortcut;
